
import { slideDown, slideUp } from "../../components/GLOBAL";


document.querySelectorAll('.front-tarifs').forEach(wrap => {
	// front-tarifs.js
(function() {
    // ------------------ НАСТРОЙКИ ------------------
    // URL, куда отправлять JSON и откуда получать новый HTML
    // Можно оставить тот же, что в action формы, или указать свой
    const API_URL = wrap.querySelector('.front-tarifs__filters').getAttribute('action');  // замените на реальный эндпоинт сервера
    
    // Контейнер, внутри которого находится сетка тарифов
    const tariffsContainer = wrap.querySelector('.front-tarifs__body ');
    
    // Все элементы фильтров (радиокнопки)
    const radioType = wrap.querySelectorAll('input[name="type"]');
    const radioTime = wrap.querySelectorAll('input[name="time"]');
    
    // ------------------ ФУНКЦИЯ ОТПРАВКИ ------------------
    async function updateTariffs() {
        if (!tariffsContainer) return;
        
        // Получаем выбранные значения
        let typeValue = '';
        let timeValue = '';
        
        for (let radio of radioType) {
            if (radio.checked) {
                typeValue = radio.value;
                break;
            }
        }
        for (let radio of radioTime) {
            if (radio.checked) {
                timeValue = radio.value;
                break;
            }
        }
        console.log('API_URL',API_URL)
         // Формируем URL с параметрами запроса
		const url = new URL(API_URL, window.location.href);
		url.searchParams.append('type', typeValue);
		url.searchParams.append('time', timeValue);
        
        // Показываем индикатор загрузки (опционально)
        tariffsContainer.style.opacity = '0.5';
        tariffsContainer.style.transition = '0.2s';
        
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                // body: JSON.stringify(requestData)
            });
            
            if (!response.ok) {
                throw new Error(`Ошибка HTTP: ${response.status}`);
            }
            
            // Ожидаем, что сервер вернёт JSON вида { "html": "<div class=\"tarif\">...</div>" }
            const data = await response.json();
            
            if (data.html) {
                tariffsContainer.innerHTML = data.html;
            } else {
                console.warn('Ответ сервера не содержит поля html');
            }
        } catch (error) {
            console.error('Ошибка загрузки тарифов:', error);
            // Можно показать сообщение пользователю
            // tariffsContainer.innerHTML = '<div class="error">Не удалось загрузить тарифы</div>';
        } finally {
            tariffsContainer.style.opacity = '1';
        }
		wrap.querySelectorAll('.tarif').forEach((item, index) => {
		if (index == 0) {
			item.classList.add('open')
		} else {
			slideUp(item.querySelector('.tarif__grid'), 30)
		}
		
		item.querySelector('.tarif__head').addEventListener('click', () => {
			
			if (item.classList.contains('open')) {
				item.classList.remove('open');
				slideUp(item.querySelector('.tarif__grid'), 300)
			} else {
				item.classList.add('open');
				slideDown(item.querySelector('.tarif__grid'), 300)
			}
		})
	})
    }
    
    // ------------------ НАВЕШИВАЕМ СЛУШАТЕЛИ ------------------
    function bindEvents() {
        // При изменении любой радиокнопки типа или времени
        const allRadios = [...radioType, ...radioTime];
        for (let radio of allRadios) {
            radio.addEventListener('change', updateTariffs);
        }
    }
    
    // ------------------ ИНИЦИАЛИЗАЦИЯ ------------------
    function init() {
        bindEvents();
        // Принудительно вызываем первый обновление,
        // чтобы подгрузить тарифы согласно текущим выбранным фильтрам
        updateTariffs();
    }
    
    // Запускаем после полной загрузки DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
})